import { useCtx } from './ctx';
import { EActions, TActions } from './types';
import { useCallback } from 'react';

export const setSortAsc: TActions['setSortAsc'] = (asc) => ({
    type: EActions.SET_SORT_ASC,
    payload: asc,
});

export const useSetSortAsc = () => {
    const [, dispatch] = useCtx();

    return useCallback((asc: boolean) => dispatch(setSortAsc(asc)), [dispatch]);
};

export const setSortHeader: TActions['setSortHeader'] = (header) => ({
    type: EActions.SET_SORT_HEADER,
    payload: header,
});

export const useSetSortHeader = () => {
    const [, dispatch] = useCtx();

    return useCallback(
        (header: string) => dispatch(setSortHeader(header)),
        [dispatch],
    );
};
